export default class CustomError extends Error {
  public statusCode: number;
  public context: any;

  constructor(message, code = 500) {
    super(message);
    this.statusCode = code;
  }
}
